module.exports = __webpack_public_path__ + "img/img13.6237771a.png";